import { pmvL10nArgs } from '_store/application/pmvLabels';
import { FluentVariable } from '@fluent/bundle';
import { useLocalization } from '@fluent/react';
import { useCallback } from 'react';

export function usePmvL10n() {
  const { l10n } = useLocalization();

  const getPmvString = useCallback(
    (id: string, args?: Record<string, FluentVariable>) =>
      l10n.getString(id, pmvL10nArgs(args)),
    [l10n],
  );

  return { getPmvString, l10n };
}
